import { call, put, select } from 'redux-saga/effects';
import { init, last } from 'ramda';
import { isTheLast2SecondsInBettingTimeSelector } from 'core/widgets/BettingTime';
import { roundStateSelector } from 'core/widgets/RoundStates';
import { IRoundState, RoundStates } from 'core/widgets/RoundStates/types';
import { clearDoubleBetAction } from 'core/widgets/BetDouble/actions';
import { clearRepeatBetAction } from 'core/widgets/BetRepeat/actions';
import { setTotalBetAction } from 'core/widgets/User/actions';
import * as Sentry from '@sentry/react';
import { ICreatePendingBetRequestData, RestService } from 'services/RestAPIService';
import { updateBetsSaga } from './createPendingBetSaga';
import { updatePlacedBetsAction } from '../actions';
import { placedBetSelector } from '../selectors';
import { BetType, IBets, IConfirmedBet } from '../types';
import { EMPTY_BET } from '../data';
import {
  betsObjToConfirmedBets,
  buildTruncatedBetPayload,
  confirmedBetsToObj,
  getBetSum,
  filterEmptyBets,
} from '../utils';
import { isCommissionModeSelector } from '../CommissionMode';

export function* cancelLastBetSaga() {
  const isTheLast2SecondsInBettingTime: boolean = yield select(
    isTheLast2SecondsInBettingTimeSelector,
  );
  const roundState: IRoundState['roundState'] = yield select(roundStateSelector);
  const isCommissionMode: boolean = yield select(isCommissionModeSelector);

  const currentBets: IBets = yield select(placedBetSelector);
  const { past } = currentBets;
  const lastFromPastBets: BetType | undefined = last(past);

  const newPast: BetType[] = lastFromPastBets ? init(past) : [];
  const newPresentBets: BetType = lastFromPastBets || EMPTY_BET;

  if (!isTheLast2SecondsInBettingTime) {
    yield call(updateBetsSaga, {
      past: newPast,
      present: newPresentBets,
    });
    yield put(clearDoubleBetAction());
    yield put(clearRepeatBetAction());
  }

  if (isTheLast2SecondsInBettingTime) {
    if (roundState === RoundStates.BettingTimeStarted) {
      const truncatedBet: BetType = buildTruncatedBetPayload(newPresentBets);
      const bets: IConfirmedBet[] = betsObjToConfirmedBets(truncatedBet, isCommissionMode);
      const betsData: ICreatePendingBetRequestData = {
        bets: filterEmptyBets(bets),
        timeStamp: new Date().getTime(),
      };

      try {
        const response: ICreatePendingBetRequestData = yield call(() =>
          RestService.createPendingBet(betsData),
        );

        const totalBet = getBetSum(confirmedBetsToObj(bets));
        yield put(setTotalBetAction(totalBet));
        yield put(updatePlacedBetsAction({ past: newPast, present: newPresentBets }));
      } catch (error) {
        Sentry.captureException({ error, betsData });
        console.log(error);
      }
    }
  }
}
